export default "__VITE_ASSET__B3jMz5O2__"